package no.vareflow.app.domain

data class AuditEvent(
    val id: String = randomId(),
    val timestamp: Long = nowMillis(),
    val actorUserId: String,
    val actorName: String,
    val action: String,
    val entityType: String,
    val entityId: String,
    val field: String = "",
    val beforeValue: String = "",
    val afterValue: String = "",
    val source: String = "app",
    val deviceId: String = "",
    val appVersion: String = "",
    val serverTimestamp: Long? = null,
    val companyId: String = DomainDefaults.DEMO_COMPANY_ID,
    val inventorySessionId: String? = null,
    val category: String? = null,
    val productId: String? = null
)
